//
// Module for the Employer Reporting Create Batch wizard's Source step
//
rs.module("employer/reporting/createbatch/sourcestep",

    ["common/visibility"],

    function (visibility) {

        // Initialize the module
        function initialize(jsSelectors, modes) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var modeRadioContainer = stepContainer.js(jsSelectors.modeRadioContainer, { required: false });
            var sourceBatchGridContainer = stepContainer.js(jsSelectors.sourceBatchGridContainer);

            // Setup listener(s) on inputs to perform actions
            modeRadioContainer.find("input").on("click", () => modeChanged());

            // Handle the mode changed event
            function modeChanged() {
                var mode = modeRadioContainer.find("input:checked").val();
                visibility.setVisible(sourceBatchGridContainer, mode == modes.copyFromPrior);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);